import { uploadMultipartFailure } from "./actions";
import axios from "axios";
import {
  getImageDimensions,
  getUploadPermissions,
  sortFilesByFormat,
} from "@helpers/files";
import { all, call, put } from "redux-saga/effects";
import { postContentTypeMap } from "@const/postManagement";
import { generateUniqueID } from "@helpers/uniqID";

export const completeMultipartUpload = async ({
  FilesService,
  uploadedFiles,
}) => {
  return await FilesService.completeMultipartUpload(uploadedFiles);
};

function* uploadMultipartSaga(permission, file) {
  const parts = [];
  const instance = axios.create();
  delete instance.defaults.headers.put["Content-Type"];

  const { uploadLinks, uploadId, file: uploadFile } = permission;

  try {
    const requests = uploadLinks.map((link, chunkIndex) => ({
      link,
      data: file?.chunks?.[chunkIndex],
    }));

    const results = yield all(
      requests.map(({ link, data }) => {
        return call(instance.put, link, data);
      }),
    );

    results.forEach((res, index) => {
      const etag = res.headers.etag.replace(/"/g, "");

      parts.push({
        etag,
        partNumber: index + 1,
      });
    });

    return {
      uploadId,
      fileId: uploadFile.id,
      key: uploadFile.fileKey,
      parts,
    };
  } catch (error) {
    yield put(uploadMultipartFailure(error));
  }
}

export function* uploadFilesSaga(files) {
  try {
    const sortedFiles = sortFilesByFormat(files);
    const filesMeta = yield all(
      sortedFiles.map(function* ({ file, chunks }) {
        const contentType = file.type;
        file.id = generateUniqueID();
        let sizes;

        if (contentType.includes(postContentTypeMap.image)) {
          sizes = yield call(getImageDimensions, file);
        }
        return { contentType, partsCount: chunks.length, ...sizes };
      }),
    );

    const permissions = yield call(getUploadPermissions, filesMeta);

    return yield all(
      permissions.map(function* (permission, index) {
        return yield call(uploadMultipartSaga, permission, sortedFiles[index]);
      }),
    );
  } catch (error) {
    yield put(uploadMultipartFailure(error));
    return [];
  }
}
